import { AccountDocument } from '../type';

export const arDocIdKeyFn = (line: AccountDocument) => `${line['AR_DOC.ID']}`;
